export default __webpack_public_path__ + "static/media/Withdrawal.c676901c.png";